<div class="card shadow-sm rounded-3">
  <div class="card-body py-2">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="fw-bold text-dark m-0 d-flex align-items-center">
          <i class="las la-home me-2"></i> {{ 'APARTMENT.RESIDENTIAL_AND_COMMERCIAL_UNITS' | translate }}
        </h4>
        <button *ngCan="service.addPermission" (click)="onAdd()" class="btn btn-primary btn-sm py-2">
          <i class="las la-plus me-1"></i> {{ 'APARTMENT.ADD_UNIT' | translate }}
        </button>
      </div>
      <p class="text-muted mb-0">{{ 'APARTMENT.OVERVIEW_OF_ALL_UNITS_IN_THIS_PROPERTY' | translate }}</p>
    <div class="mt-2">
      <p-table
        [hasList]="service.hasList"
        (delete)="onDelete($event)"
        (edit)="onEdit($event)"
        (onLazyLoad)="loadData($event)"
        (onPage)="pageChange($event)"
        (view)="onView($event)"
        [columns]="service.fields"
        [dataKey]="'id'"
        [first]="first"
        [globalSearch]="globalSearch"
        [hasActions]="service.hasActions"
        [hasAdd]="false"
        [hasDelete]="false"
        [hasEdit]="false"
        [hasView]="false"
        [loading]="loading()"
        [rows]="rows"
        [selectionMode]="'single'"
        [title]="service.title"
        [totalRecords]="total"
        [value]="list"
        paginatorPosition="bottom"
        tableStyleClass="table table-hover custom-table"
      >
        <ng-template #cells let-data>
          @for (col of service.fields; track col) {
            <td>
              <span class="p-datatable-column-title">
                  @if (col.iconClass) {
                    <i [class]="col.iconClass"></i>
                  }
                {{ (col.label ?? col.fieldName) | translate }}
              </span>
              @switch (col.fieldName) {
              @case ('rentalContract') {
                @if (data.rentalContract && data.rentalContract.fullName) {
                  <a [routerLink]="[Resources.RentersDetails | resourceById:data.rentalContract.renterId]" 
                     class="text-decoration-none text-primary fw-medium">
                    {{ data.rentalContract.fullName }}
                  </a>
                } @else {
                  <span class="text-muted">-</span>
                }
              }

              @case ('actions') {
                  <a *ngCan="service.viewPermission" [routerLink]="[Resources.UniversalBillingApartmentsProfile | resourceById:data.id]"
                     ngbTooltip="{{'INVOICES.DETAILS'|translate}}"
                     class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center action-button">
                    <i class="las la-info-circle fs-20"></i>
                  </a>
              }
              @default {
                  <p-table-cell-value [data]="data" [column]="col"></p-table-cell-value>
              }
            }
            </td>
          }
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
